export let Network;

(function (Network) {
  Network["MAIN"] = "f";
  Network["TEST"] = "t";
})(Network || (Network = {}));
//# sourceMappingURL=network.js.map